class PartnerMarquee extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    if (window.innerWidth <= 1023) {
      this.initSlider();
    } else {
      this.initDesktopSlider();
    }
  }
  shuffleArray(array) {
    return array.map((value) => ({ value, sort: Math.random() })).sort((a, b) => a.sort - b.sort).map(({ value }) => value);
  }
  initSlider() {
    const originalRows = Array.from(this.children);
    if (!originalRows.length) return;
    const shuffledLogos = this.shuffleArray(originalRows);
    const chunkSize = Math.ceil(shuffledLogos.length / 3);
    const rows = [];
    for (let i = 0; i < 3; i++) {
      const rowLogos = shuffledLogos.slice(i * chunkSize, (i + 1) * chunkSize);
      if (rowLogos.length > 0) {
        const direction = i % 2 === 0 ? "left" : "right";
        const duplicatedContent = [...rowLogos, ...rowLogos].map((row) => row.innerHTML).join("");
        rows.push({
          direction,
          content: `<div class="logo-wrapper">${duplicatedContent}</div>`
        });
      }
    }
    this.shadowRoot.innerHTML = `
        <style>
            .slider-container {
                max-width: 100%;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                gap: 16px;
            }
            .row {
                display: flex;
                width: max-content;
                gap: 24px;
            }
            .row[data-direction="left"] {
                animation: slide-left 9s linear infinite;
            }
            .row[data-direction="right"] {
                animation: slide-right 9s linear infinite;
            }
            @keyframes slide-left {
                from { transform: translateX(0%); }
                to { transform: translateX(-50%); }
            }
            @keyframes slide-right {
                from { transform: translateX(-50%); }
                to { transform: translateX(0%); }
            }
            .items-center {
                flex-shrink: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 172px;
                height: 70px;
                border: 1px solid #2A2A2A;
                border-radius: 24px;
                backdrop-filter: blur(7.5px);
            }
            .slide img {
                max-width: 120px;
                max-height: 70px;
                object-fit: contain;
            }
            .logo-wrapper {
                display: flex;
                gap: 16px;
            }
            @media(max-width: 749px) {
                .partner {
                    border: 1px solid #2f2f2f;
                    border-radius: 24px;
                }
            }
        </style>
        <div class="slider-container">
            ${rows.map(
      (row) => `
                        <div class="row" data-direction="${row.direction}">
                            ${row.content}
                        </div>
                    `
    ).join("")}
        </div>
    `;
  }
  initDesktopSlider() {
    const originalChildren = Array.from(this.children);
    if (!originalChildren.length) return;
    const content = originalChildren.map((child) => `<div class="logo-wrapper">${child.innerHTML}</div>`).join("");
    const repeatedContent = content + content;
    this.shadowRoot.innerHTML = `
          <style>
           .logo-wrapper{
            border: 1px solid #2F2F2F;
            min-width: 200px;
            border-radius: 32px;
            height: 86px;
            display: flex;
            align-items: center;
            justify-content: center;
            }
  
            .logo-wrapper img{
            max-width: 172px;
            }
            .slider-container {
              max-width: 100%;
              overflow: hidden;
            }
            .row {
              display: flex;
              gap: 24px;
              white-space: nowrap;
              animation: slide-left-desktop 20s linear infinite;
            }
            @keyframes slide-left-desktop {
              from { transform: translateX(0%); }
              to { transform: translateX(-50%); }
            }
            .items-center {
              flex-shrink: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 172px;
              height: 70px;
              border: 1px solid #2A2A2A;
              border-radius: 24px;
              backdrop-filter: blur(7.5px);
            }
            .slide img {
              max-width: 120px;
              max-height: 70px;
              object-fit: contain;
            }
          </style>
          <div class="slider-container">
            <div class="row">
              ${repeatedContent}
            </div>
          </div>
        `;
  }
}
if (!customElements.get("partner-marquee")) {
  customElements.define("partner-marquee", PartnerMarquee);
}
